export type ThemeColor = keyof typeof ThemeColors;

export const ThemeColors = {
  neutral: 'neutral',
  white: 'white',
  primary: 'primary',
  success: 'success',
  failure: 'failure',
  warning: 'warning',
  brown: 'brown',
  rust: 'rust',
  magenta: 'magenta',
  purple: 'purple',
  slate: 'slate',
  teal: 'teal',
  olive: 'olive',
  transparent: 'transparent',
} as const;

export const allColors = Object.keys(ThemeColors) as ThemeColor[];

export type ThemeDensity =
  | 'most-compact'
  | 'compact'
  | 'default'
  | 'comfortable'
  | 'most-comfortable';

export type ThemeSizeVariant = 'small' | 'medium' | 'large';

export type ColorScheme = 'light' | 'dark';
